import React, { memo } from 'react'

import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

import FooterActions from './Components/FooterActions/FooterActions'
import ViewerArea from './Components/ViewerArea/ViewerArea'

function RightSide() {
  const modelUrl = useThreeDStudioStore(state => state.ui.openedModel?.outputAssets?.[0]?.fileUrl)
  const shouldShowFooterActions = Boolean(modelUrl)

  return (
    <div className="main-panel__right-side">
      <ViewerArea />
      {shouldShowFooterActions && <FooterActions />}
    </div>
  )
}

export default memo(RightSide)
